export default "__VITE_ASSET__40190151__"